import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import {aggregatefunction} from 'utils/enums/rollup'
import Filters from './Filters'
import {getFilterFields} from 'utils/utils'
import {fieldtype} from 'utils/enums/fieldtype'

const Error = styled.div`
    margin-top: 7px;
    color: #d45b4a;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    padding-bottom: 7px;
    margin-bottom: 20px;
`

const Label = styled.div`
    color: rgba(0, 0, 0, 0.54);
    font-size: 12px;
`

const Control = styled(FormControl)`
	margin-bottom: 20px;
	width: 100%;
`

class RollupDefinition extends React.Component {
    formatFilters = (fields) => {
        const filters = []

        this.props.filters.forEach(item => {
            const filter = {...item}

            filter.field = fields.find(field => field.id === filter.fieldId).fieldId
            filter.fieldType = fields.find(field => field.id === filter.fieldId).type
            filter.pathName = fields.find(field => field.id === filter.fieldId).pathName
            filters.push(filter)

            if (filter.fieldType === fieldtype.linkedfield && !this.props.options[filter.field]) {
                this.props.fetchLinkedOptions(filter.field)
            }
        })

        return filters
    }

    render() {
        const { intl, labelFields, fields, entities, entity } = this.props
        const table = entities && entities.find(item => item.id === entity)
        const filterIds = this.props.filters.map(item => item.fieldId)
        const filterFields = getFilterFields(entity, this.props.groupField ? [this.props.groupField, ...filterIds] : [...filterIds])
        const filters = this.formatFilters(filterFields)

        return (
            <React.Fragment>
                {entities && entities.length &&
                    <Control variant="standard">
                        <InputLabel>{intl.formatMessage({id: "main.rollup_entity"})}</InputLabel>
                        <Select
                            value={entity}
                            onChange={this.props.onChange}
                            inputProps={{
                                name: 'entity'
                            }}
                        >
                            {entities.map((item, index) =>
                                <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                            )}
                        </Select>
                    </Control>
                }
                <Control variant="standard">
                    <InputLabel>{intl.formatMessage({id: "main.rollup_aggregate"})}</InputLabel>
                    <Select
                        value={this.props.calc}
                        onChange={this.props.onChange}
                        inputProps={{
                            name: 'calc'
                        }}
                    >
                        {Object.keys(aggregatefunction).map((item, index) =>
                            <MenuItem key={index} value={aggregatefunction[item]}>
                                {intl.formatMessage({id: `main.rollup_aggregatefunction_${aggregatefunction[item]}`})}
                            </MenuItem>
                        )}
                    </Select>
                </Control>
                {!!fields.length && this.props.calc !== aggregatefunction.Count &&
                    <Control variant="standard">
                        <InputLabel>
                            {this.props.graphic ? intl.formatMessage({id: "main.rollup_graphic_field"}) : intl.formatMessage({id: "main.rollup_widget_field"})}
                        </InputLabel>
                        <Select
                            value={this.props.field}
                            onChange={this.props.onChange}
                            inputProps={{
                                name: 'field'
                            }}
                        >
                            {fields.map((item, index) =>
                                <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                            )}
                        </Select>
                    </Control>
                }
                {!fields.length && this.props.calc !== aggregatefunction.Count && table &&
                    <React.Fragment>
                        <Label>
                            {this.props.graphic ? intl.formatMessage({id: "main.rollup_graphic_field"}) : intl.formatMessage({id: "main.rollup_widget_field"})}
                        </Label>
                        <Error>No number fields found in {table.singular}</Error>
                    </React.Fragment>
                }
                {this.props.graphic &&
                    <React.Fragment>
                        {labelFields && !!labelFields.length &&
                            <Control variant="standard">
                                <InputLabel>{intl.formatMessage({id: "main.rollup_label_field"})}</InputLabel>
                                    <Select
                                        value={this.props.groupField}
                                        onChange={this.props.onChange}
                                        inputProps={{
                                            name: 'groupField'
                                        }}
                                    >
                                        {labelFields.map((item, index) =>
                                            <MenuItem key={index} value={item.id}>{item.pathName}</MenuItem>
                                        )}
                                    </Select>
                            </Control>
                        }
                        {labelFields && !labelFields.length && table &&
                            <React.Fragment>
                                <Label>{intl.formatMessage({id: "main.rollup_label_field"})}</Label>
                                <Error>No fields found in {table.singular}</Error>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }
                {!!filterFields.length &&
                    <Filters
                        filterFields={filterFields}
                        filters={filters}
                        changeFilters={this.props.changeFilters}
                        options={this.props.options}
                    />
                }
            </React.Fragment>
        )
    }
}

export default injectIntl(RollupDefinition)
